module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-cn-m@3x.2d6ff78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-cn-m@3x.png
// module id = XB/A
// module chunks = 18